import React, { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { Avatar, Card, CardContent } from '@material-ui/core';

interface PlayerListItemContainerProps {
  $highlight?: boolean;
}

export const SpacedCard = styled(Card)<PlayerListItemContainerProps>`
  ${(props) =>
    !props.$highlight &&
    css`
      margin-bottom: 16px;
    `}

  &:hover {
    ${(props) =>
      props.$highlight &&
      css`
        box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 10px;
      `}
  }

  & + & {
    margin-top: 16px;
  }
`;

export const PlayerListItemContainer = ({ children, $highlight }: PropsWithChildren<PlayerListItemContainerProps>) => {
  return (
    <SpacedCard variant='outlined' $highlight={$highlight}>
      <CardContent>{children}</CardContent>
    </SpacedCard>
  );
};

export const PlayerAvatar = styled(Avatar)`
  float: left;
  width: 60px;
  height: 60px;
  margin-right: 16px;
  margin-bottom: 16px;
`;

export const ButtonArea = styled.div`
  float: right;
  margin-left: 16px;
`;

export const NameArea = styled.div`
  margin-bottom: 16px;
  font-size: 1.4rem;
`;

export const MainInfoArea = styled.div`
  margin-bottom: 16px;
`;
